<!-- xlsx.js (C) 2013-present  SheetJS -- http://sheetjs.com -->
<template>
  <div @drop="_drop" @dragenter="_suppress" @dragover="_suppress">
    <div class="row">
      <div class="col-xs-12">
        <v-btn color="orange" @click="$refs.fileImport.click()" dark rounded>
          <v-icon>mdi-upload</v-icon>
          <span>Importar</span>
        </v-btn>
        <input
          hidden
          ref="fileImport"
          type="file"
          accept=".xlsx, .xls, .csv"
          multiple="false"
          @change="_change"
        />
      </div>
    </div>
    <v-dialog v-model="showTableDialog" max-width="900" persistent>
      <v-card v-if="importStatus === 'loading'">
        <v-card-text class="pt-7 d-flex align-center">
          <span class="title">Importando datos...</span>
        </v-card-text>
      </v-card>
      <v-card v-if="importStatus === 'success'">
        <v-card-text class="pt-7">
          <span class="title">Se ha importado correctamente el archivo</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="showTableDialog = false" color="primary" rounded
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
      <v-card v-if="importStatus === 'error'">
        <v-card-text class="pt-7">
          <span class="title">Ha ocurrido un error al importar archivo</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="showTableDialog = false" color="primary" rounded
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
      <v-card v-if="importStatus === 'start'">
        <v-card-title class="primary--text">
          <span>Importar archivo</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="showTableDialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <div class="pa-4 pt-8">
          <v-data-table
            :headers="cols"
            :items="data"
            :items-per-page="10"
            class="elevation-1"
          ></v-data-table>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="importData" color="primary" rounded
            >Importar datos</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const make_cols = refstr =>
  Array(XLSX.utils.decode_range(refstr).e.c + 1)
    .fill(0)
    .map((x, i) => ({ name: XLSX.utils.encode_col(i), key: i }));
const _SheetJSFT = [
  "xlsx",
  "xlsb",
  "xlsm",
  "xls",
  "xml",
  "csv",
  "txt",
  "ods",
  "fods",
  "uos",
  "sylk",
  "dif",
  "dbf",
  "prn",
  "qpw",
  "123",
  "wb*",
  "wq*",
  "html",
  "htm"
]
  .map(function(x) {
    return "." + x;
  })
  .join(",");

import XLSX from "xlsx";

export default {
  data() {
    return {
      fileInput: null,
      showTableDialog: false,
      dialogImportSuccess: false,
      dialogImportError: false,
      importStatus: "start",
      //
      data: [],
      cols: [],
      SheetJSFT: _SheetJSFT
    };
  },
  methods: {
    _suppress(evt) {
      evt.stopPropagation();
      evt.preventDefault();
    },
    _drop(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      const files = evt.dataTransfer.files;
      if (files && files[0]) this._file(files[0]);
    },
    _change(evt) {
      const [file] = evt.target.files || [];
      this.$refs.fileImport.value = null;
      this.$refs.fileImport.files = null;
      if (file) this._file(file);
    },
    _export(evt) {
      /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(this.data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      /* generate file and send to client */
      XLSX.writeFile(wb, "sheetjs.xlsx");
    },
    _file(file) {
      /* Boilerplate to set up FileReader */
      const reader = new FileReader();
      reader.onload = e => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const [...data] = XLSX.utils.sheet_to_json(ws, {
          raw: true,
          defval: ""
        });

        const enabledCols = [
          "vernacularName",
          "scientificName",
          "scientificNameID",
          "kingdom",
          "phylum",
          "className",
          "order",
          "family",
          "genus",
          "specificEpithet",
          "scientificNameAuthorship",
          "LT_max",
          "LT_mid",
          "depth_range",
          "TPMS_field",
          "N_max",
          "W_min",
          "veda",
          "locality_CL",
          "habitat",
          "biology",
          "fisheries",
          "conservation",
          "references",
          "card_author",
          "sp_card"
        ];

        /* Update state */
        this.cols = enabledCols.map((key, index) => ({
          text: key,
          align: "start",
          sortable: false,
          value: key
        }));
        this.data = data.map(item => {
          let itemMapped = {};
          for (let col of enabledCols) {
            itemMapped[col] = item[col];
          }
          return itemMapped;
        });
        this.showTableDialog = true;
      };
      reader.readAsBinaryString(file);
    },
    async importData() {
      this.importStatus = "loading";
      try {
        let data = this.data.map(item => {
          for (let key in item) {
            if (item[key] === "") {
              delete item[key];
            }
            if (
              typeof item[key] === "string" &&
              item[key].toLowerCase() === "false"
            ) {
              item[key] = false;
            }
            if (
              typeof item[key] === "string" &&
              item[key].toLowerCase() === "true"
            ) {
              item[key] = true;
            }
          }
          return item;
        });
        await this.$http.post("organism/import", { data });
        this.$emit("import");
        this.importStatus = "success";
        this.data = [];
      } catch (err) {
        console.log(err);
        this.importStatus = "error";
      }
    }
  },
  watch: {
    showTableDialog(value) {
      if (value === false) {
        this.importStatus = "start";
        this.data = [];
      }
    }
  }
};
</script>
